import script from "./MemoryInterpretationGame.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoryInterpretationGame.vue?vue&type=script&setup=true&lang=js"

import "./MemoryInterpretationGame.vue?vue&type=style&index=0&id=9c04e986&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c04e986"]])

export default __exports__